<div class="page-header-container">
    <div class="page-title">
        {{ (contractsFilter.activeContracts ? 'contracts.titleActive' : 'contracts.titleClosed') | translate}}
    </div>
</div>
<div class="header-buttons-box">
    <div class="flex-grow-1 custom-text-input-container search-container contract-search-container">
        <i class="app-icon icon icon-search icon-xl"></i>
        <div class="custom-text-input-wrap">
            <kendo-textbox
                #contractSearch
                type="text"
                [clearButton]='true'
                placeholder="{{'contracts.searchPlaceholder' | translate }}"
                [(ngModel)]="contractsFilter.searchText"
                (valueChange)="searchQuery$.next({ value: $event, force: $event === '' })">
            </kendo-textbox>
        </div>
    </div>

    <button class="btn white-btn text-uppercase" (click)="toggleContractListState()">
        <span>
            {{ (contractsFilter.activeContracts ? 'contracts.viewClosedContracts' : 'contracts.viewActiveContracts') | translate | uppercase}}
        </span>
    </button>
    
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'contracts.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'contracts.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>

    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>        
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<contracts-card-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasData" 
    [contracts]="contracts" 
    [props]="contractsProps" 
    (viewDetails)="redirectDetails($event)">
</contracts-card-view>
<contracts-list-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasData" 
    [contracts]="contracts" 
    [props]="contractsProps" 
    (viewDetails)="redirectDetails($event)">
</contracts-list-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
